import { FC } from 'react';
import theme from '../../../theme';
import Icon from '../Icon';

interface Props {
  width?: string;
  /** A theme colour name (e.g. 'primary') or any CSS colour. */
  color?: string;
}

const UploadIcon: FC<Props> = ({ width = '20', color }) => (
  <Icon
    name="upload"
    size={Number(width) || width}
    color={(theme.colors.general as Record<string, string>)[color] || color || theme.colors.general.textSecondary}
  />
);

export default UploadIcon;
